export default __webpack_public_path__ + "static/media/damian_lilly.73a15ccc.mp3";